import { render, staticRenderFns } from "./switchLanguage.vue?vue&type=template&id=05e51e71&scoped=true&"
import script from "./switchLanguage.vue?vue&type=script&lang=js&"
export * from "./switchLanguage.vue?vue&type=script&lang=js&"
import style0 from "./switchLanguage.vue?vue&type=style&index=0&id=05e51e71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e51e71",
  null
  
)

export default component.exports